"use strict";

define('rs/modals/proposal.finder/proposal.finder.view',['../table.finder/table.finder.view', 'rs/language'], function (TableFinderView, Language) {
  var ProposalFinderView = TableFinderView.extend({
    render: function render() {
      var delegate = this.getDelegate();
      this._super.apply(this, arguments);
      $(document.createElement('div')).addClass('content-margin-small').append('Researchers: ').append(_.invoke(delegate.getPeople(), 'getDisplayName').join(', ')).append('&nbsp; &nbsp;').append($(document.createElement('span')).addClass('fa-icon fa-icon-info-circle').attr('title', Language.phrase('Proposal.Finder.Info.Tooltip')).attr('data-toggle', 'tooltip').attr('data-placement', 'right').tooltip()).insertBefore(this.$('.finder-container'));
    }
  });
  return ProposalFinderView;
});

